import sanityClient from "@sanity/client";

export default sanityClient({ projectId: "29hjj1yl", dataset: "production" });
